import React from "react";
import "./../styles/Terms.css";

const Terms = () => {
  return (
    <div className="lh-legal-page">
      <section className="lh-legal-hero">
        <p className="lh-legal-eyebrow">Nutzungsbedingungen</p>
        <h1>Allgemeine Geschäftsbedingungen</h1>
        <p>
          Diese Bedingungen definieren die Nutzung der LearnHut-Plattform und den
          rechtlichen Rahmen der bereitgestellten Lerninhalte.
        </p>
      </section>

      <section className="lh-legal-layout">
        <aside className="lh-legal-toc">
          <p>Inhaltsverzeichnis</p>
          <a href="#terms-1">1. Geltungsbereich</a>
          <a href="#terms-2">2. Vertragsgegenstand</a>
          <a href="#terms-3">3. Registrierung und Nutzung</a>
          <a href="#terms-4">4. Preise und Zahlungsbedingungen</a>
          <a href="#terms-5">5. Haftungsausschluss</a>
          <a href="#terms-6">6. Nutzungsrechte</a>
          <a href="#terms-7">7. Änderungen der AGB</a>
          <a href="#terms-8">8. Kündigung und Löschung des Kontos</a>
          <a href="#terms-9">9. Anwendbares Recht</a>
        </aside>

        <article className="lh-legal-article">
          <section id="terms-1">
            <h2>1. Geltungsbereich</h2>
            <p>
              Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Nutzung
              unserer E-Learning-Plattform. Mit der Registrierung und Nutzung
              unserer Plattform erklärst du dich mit diesen AGB einverstanden.
              Bitte lies diese sorgfältig durch, bevor du die Dienste in
              Anspruch nimmst.
            </p>
          </section>

          <section id="terms-2">
            <h2>2. Vertragsgegenstand</h2>
            <p>
              Wir bieten Studierenden digitale Inhalte, Kurse und Lernmaterialien
              an, die dazu dienen, schwer verständliche Universitätsfächer zu
              meistern. Zusätzlich ermöglichen wir den Zugriff auf frühere
              Prüfungsaufgaben zur praktischen Vorbereitung.
            </p>
          </section>

          <section id="terms-3">
            <h2>3. Registrierung und Nutzung</h2>
            <ul>
              <li>
                Zur Nutzung unserer Plattform ist eine Registrierung erforderlich.
                Du bist verpflichtet, wahrheitsgemäße Angaben zu machen und deine
                Zugangsdaten vertraulich zu behandeln.
              </li>
              <li>
                Die Nutzung ist ausschließlich für private, nicht kommerzielle
                Zwecke gestattet.
              </li>
            </ul>
          </section>

          <section id="terms-4">
            <h2>4. Preise und Zahlungsbedingungen</h2>
            <ul>
              <li>
                Einige Inhalte unserer Plattform sind kostenpflichtig. Die Preise
                werden vor Abschluss des Kaufs deutlich angegeben.
              </li>
              <li>
                Zahlungen erfolgen über die angegebenen Zahlungsmethoden. Bei Fragen
                zu Zahlungen wende dich bitte an unseren Support.
              </li>
            </ul>
          </section>

          <section id="terms-5">
            <h2>5. Haftungsausschluss</h2>
            <ul>
              <li>
                Wir bemühen uns, alle Inhalte aktuell und korrekt bereitzustellen,
                übernehmen jedoch keine Haftung für Fehler oder veraltete
                Informationen.
              </li>
              <li>
                Der Zugriff auf frühere Prüfungsaufgaben dient nur zu Übungszwecken
                und garantiert keinen Prüfungserfolg.
              </li>
            </ul>
          </section>

          <section id="terms-6">
            <h2>6. Nutzungsrechte</h2>
            <ul>
              <li>
                Alle Inhalte unserer Plattform sind urheberrechtlich geschützt. Es
                ist nicht gestattet, Inhalte zu kopieren, weiterzugeben oder
                anderweitig kommerziell zu nutzen.
              </li>
              <li>
                Bei Verstößen behalten wir uns das Recht vor, den Zugang zu sperren.
              </li>
            </ul>
          </section>

          <section id="terms-7">
            <h2>7. Änderungen der AGB</h2>
            <p>
              Wir behalten uns das Recht vor, diese AGB bei Bedarf anzupassen. Über
              wesentliche Änderungen informieren wir dich rechtzeitig. Mit der
              fortgesetzten Nutzung der Plattform erklärst du dich mit den
              Änderungen einverstanden.
            </p>
          </section>

          <section id="terms-8">
            <h2>8. Kündigung und Löschung des Kontos</h2>
            <p>
              Du kannst dein Konto jederzeit über die Kontoeinstellungen löschen.
              Bereits bezahlte Beträge werden nicht erstattet, es sei denn,
              gesetzliche Regelungen sehen dies vor.
            </p>
          </section>

          <section id="terms-9">
            <h2>9. Anwendbares Recht</h2>
            <p>
              Es gilt das Recht der Bundesrepublik Deutschland. Der Gerichtsstand
              ist, soweit gesetzlich zulässig, der Sitz unseres Unternehmens.
            </p>
          </section>
        </article>
      </section>
    </div>
  );
};

export default Terms;
